module.exports = __webpack_public_path__ + "img/summer-veggie-gazpacho.8e17e713.jpg";